<template>
    <div class="sell-card-content">
        <b-row
            v-for="(item, index) in card.items"
            :key="index"
        >
            <b-col class="d-flex">
                <i class="far fa-check mt-1" />

                <div class="ml-3">
                    <h2 class="card-item-title">
                        {{ item.title }}
                    </h2>

                    <p class="card-item-content">
                        {{ item.content }}
                    </p>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import './SellCardContent.scss';

    export default {
        name: 'SellCardContent',

        props: {
            card: {
                type: Object,
                required: true,
            }
        }
    };
</script>
